import { httpRequest } from "@services/http";
import { Budget, BudgetType, ReplenishFrequency } from "@models/budget.model";
import { BudgetSerializer } from "@models/serializers/budgetSerializer";

export interface CreateBudgetPayload {
  contract_id: number;
  budget_type: BudgetType;
  starting_balance: number;
  replenish_amount?: number | null;
  replenish_frequency?: ReplenishFrequency | null;
  start_date: string;
  end_date?: string | null;
  is_active?: boolean;
}

export class CommandCreateBudget {
  async run(payload: CreateBudgetPayload): Promise<Budget> {
    const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/finance/budgets/`;
    const response = await httpRequest<any>(url, {
      method: "POST",
      body: JSON.stringify(payload),
    });
    return BudgetSerializer.fromJson(response);
  }
}
